// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loader {
  position: absolute;
}

.loader span {
  position: absolute;
  color: #fff;
  transform: translate(-50%, -50%);
  font-size: 38px;
  letter-spacing: 5px;
}

.loader span:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 0.8px #0077bd;
}

.loader span:nth-child(2) {
  color: #0077bd;
  -webkit-text-stroke: 1px #0077bd;
  animation: uiverse723 3s ease-in-out infinite;
}

@keyframes uiverse723 {
  0%, 100% {
    clip-path: polygon(0% 45%, 15% 44%, 32% 50%, 
     54% 60%, 70% 61%, 84% 59%, 100% 52%, 100% 100%, 0% 100%);
  }

  50% {
    clip-path: polygon(0% 60%, 16% 65%, 34% 66%, 
     51% 62%, 67% 50%, 84% 45%, 100% 46%, 100% 100%, 0% 100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Loader/Loader.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE;IACE;6DACyD;EAC3D;;EAEA;IACE;6DACyD;EAC3D;AACF","sourcesContent":["\n.loader {\n  position: absolute;\n}\n\n.loader span {\n  position: absolute;\n  color: #fff;\n  transform: translate(-50%, -50%);\n  font-size: 38px;\n  letter-spacing: 5px;\n}\n\n.loader span:nth-child(1) {\n  color: transparent;\n  -webkit-text-stroke: 0.8px #0077bd;\n}\n\n.loader span:nth-child(2) {\n  color: #0077bd;\n  -webkit-text-stroke: 1px #0077bd;\n  animation: uiverse723 3s ease-in-out infinite;\n}\n\n@keyframes uiverse723 {\n  0%, 100% {\n    clip-path: polygon(0% 45%, 15% 44%, 32% 50%, \n     54% 60%, 70% 61%, 84% 59%, 100% 52%, 100% 100%, 0% 100%);\n  }\n\n  50% {\n    clip-path: polygon(0% 60%, 16% 65%, 34% 66%, \n     51% 62%, 67% 50%, 84% 45%, 100% 46%, 100% 100%, 0% 100%);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
